module.exports = "<a href=\"javascript:void(0);\" class=\"closeDialog\">\r\n  <i class=\"material-icons\">close</i>\r\n</a>\r\n"